export default class FooterSignup {
  constructor(footerEmailContainer) {
    this.footerEmailContainer = footerEmailContainer;
    this.emailInput = this.footerEmailContainer.querySelector('.js-footer-email');
    this.nextButton = this.footerEmailContainer.querySelector('.js-footer-email-cta');
    this.formEmailInput = document.querySelector('input[type="email"]');

    if (this.emailInput && this.nextButton) {
      this.nextButton.addEventListener('click', (event) => {
        const email = this.emailInput.value.trim();
    
        // Validate the email format before storing
        if (email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          localStorage.setItem('email', email);
        } else {
          event.preventDefault();
          alert('Please enter a valid email address.');
        }
      });
    }

    if (this.formEmailInput) {
      const storedEmail = localStorage.getItem('email');

      if (storedEmail) {
        const emailInput = document.querySelector('input#input_8_1[type="email"]');
  
        if (emailInput) {
          emailInput.value = storedEmail; // Populate the email field
        }
      }
    }
  }
}